
import { React,useEffect,useState } from 'react';
import { useLocation } from 'react-router-dom';
import { apiurl } from '../common/constants';
import ItemCard from './ItemCard';
import Footer from './Footer';
import Pagination from './subcomponents/Pagination';
import { useStore } from '../context/StoreContext';


export default function Search() {
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery()
    const [searchData, setSearchData] = useState(null)
    const [pageCount,setPageCount] = useState(1)

    // Price Filter State
    const [minPrice, setMinPrice] = useState('');
    const [maxPrice, setMaxPrice] = useState('');
    const [applyFilter, setApplyFilter] = useState(false); // Trigger refetch on apply

    // Sort and Mobile Filter State
    const [sortBy, setSortBy] = useState('latest');
    const [showFilter, setShowFilter] = useState(false);

    // store
    const {setIsLoading} = useStore();

    const productPerPage = 36; // Adjusted to be divisible by 2, 3, 4 for grid

    const handlepageclick = (newCount) =>{
        if (newCount > 0 && newCount <=Math.ceil(searchData.totalProductCount / productPerPage) ){
          setPageCount(newCount)
        }
      }

    useEffect(()=>{
        let bodyContent = {
            searchQuery:query.get('q'),
            categoryType:query.get('categorytype'), //["Main","Sub","All"]
            categoryType_ref:query.get('ref'),
            productPerPage:productPerPage,
            pageNumber:pageCount,
            latest: sortBy === 'latest', // Maintain backward compatibility if needed, or rely on sortBy
            sortBy: sortBy
        };

        if (minPrice) bodyContent.minPrice = parseInt(minPrice);
        if (maxPrice) bodyContent.maxPrice = parseInt(maxPrice);
        setIsLoading(true);
        fetch(apiurl+"/search",{
            method:"POST",
            body: JSON.stringify(bodyContent),
            headers:{
                "Content-Type":"application/json"
            }
        }).then(res=>res.json())
        .then(data=>{
            setSearchData(data)
            setIsLoading(false);
            window.scrollTo(0, 0);
        })
        .catch(err=>{
            console.error("Error fetching search data:", err);
            setIsLoading(false);
        });
        

    },[pageCount,query.get('q'),query.get('ref'),query.get('categorytype'), applyFilter, sortBy])

    useEffect(()=>{
        setPageCount(1)
        // Reset filters when query changes? Optional, but good UX.
        // setMinPrice('');
        // setMaxPrice('');
    },[query.get('q'),query.get('ref'),query.get('categorytype')])

    const handleFilterApply = () => {
        setPageCount(1);
        setApplyFilter(prev => !prev); // Toggle to trigger useEffect
    }


  return (
    <>
    <div className="container-fluid px-lg-5 mt-4" style={{"minHeight":"60vh"}}>
        {/* Mobile Filter Toggle Button */}
        <div className="d-md-none mb-3">
            <button 
                className="btn btn-outline-dark w-100 d-flex justify-content-between align-items-center"
                onClick={() => setShowFilter(!showFilter)}
            >
                <span><i className="bi bi-funnel"></i> Filters</span>
                <span>{showFilter ? 'Hide' : 'Show'}</span>
            </button>
        </div>

        <div className="row">
            {/* Left Sidebar - Filters */}
            <div className={`col-12 col-md-3 col-lg-2 mb-4 ${showFilter ? '' : 'd-none d-md-block'}`}>
                <div className="card shadow-sm border-0">
                    <div className="card-body p-3">
                        <h5 className="card-title mb-3 fw-bold">Filter By</h5>
                        
                        <div className="mb-3">
                            <label className="form-label">Price Range</label>
                            <div className="d-flex align-items-center mb-2">
                                <input 
                                    type="number" 
                                    className="form-control me-2" 
                                    placeholder="Min" 
                                    value={minPrice}
                                    onChange={(e) => setMinPrice(e.target.value)}
                                />
                                <span className="text-muted">-</span>
                                <input 
                                    type="number" 
                                    className="form-control ms-2" 
                                    placeholder="Max" 
                                    value={maxPrice}
                                    onChange={(e) => setMaxPrice(e.target.value)}
                                />
                            </div>
                            <button 
                                className="btn btn-dark w-100 mt-2"
                                onClick={handleFilterApply}
                            >
                                Apply Filter
                            </button>
                        </div>

                        {/* Predefined Price Ranges */}
                        <div className="mb-3">
                            <label className="form-label text-muted small">Price Ranges</label>
                            {[
                                { min: 0, max: 1000, label: "Rs. 0 - Rs. 1000" },
                                { min: 1000, max: 5000, label: "Rs. 1000 - Rs. 5000" },
                                { min: 5000, max: 10000, label: "Rs. 5000 - Rs. 10000" },
                                { min: 10000, max: 20000, label: "Rs. 10000 - Rs. 20000" },
                                { min: 20000, max: 100000, label: "Rs. 20000+" }
                            ].map((range, index) => (
                                <div className="form-check" key={index}>
                                    <input 
                                        className="form-check-input" 
                                        type="checkbox" 
                                        name="priceRange"
                                        id={`priceRange${index}`}
                                        checked={
                                            parseInt(minPrice) === range.min && 
                                            parseInt(maxPrice) === range.max
                                        }
                                        onChange={() => {
                                            setMinPrice(range.min);
                                            setMaxPrice(range.max);
                                            setTimeout(() => setApplyFilter(prev => !prev), 0);
                                        }}
                                    />
                                    <label className="form-check-label" htmlFor={`priceRange${index}`}>
                                        {range.label}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Right Side - Search Results */}
            <div className="col-12 col-md-9 col-lg-10">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3 className='heading-font mb-0'>Search Result:</h3>
                    
                    <div className="d-flex align-items-center">
                        <label className="me-2 d-none d-sm-block text-muted">Sort by:</label>
                        <select 
                            className="form-select w-auto border-secondary" 
                            style={{minWidth: '150px'}}
                            value={sortBy}
                            onChange={(e) => setSortBy(e.target.value)}
                        >
                            <option value="latest">New Arrival</option>
                            <option value="price_asc">Price: Low to High</option>
                            <option value="price_desc">Price: High to Low</option>
                        </select>
                    </div>
                </div>

                <div className='row row-cols-2 row-cols-md-4 row-cols-lg-5 row-cols-xl-6 g-3'>
                    {searchData && (searchData.data.length === 0) ? (
                        <div className="col-12 text-center py-5">
                            <h4>No Products Found</h4>
                            <p className="text-muted">Try adjusting your filters or search query.</p>
                        </div>
                    ) : ""}
                    
                    {searchData && searchData.data.map((elem) => (
                        <div className='col' key={elem._id}>
                            <ItemCard img={elem} />
                        </div>
                    ))}
                </div>

                {/* Pagination */}
               {searchData && searchData.data.length > 0 && (
                    <Pagination
                        currentPage={pageCount}
                        totalPages={Math.ceil(searchData.totalProductCount / productPerPage)}
                        onPageChange={handlepageclick}
                    />
               )}
            </div>
        </div>
    </div>
    <Footer />
    </>
  )
}
